import { cn } from 'cn';
import { useEnvironment } from '@/app/environment';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Amber outline chips on the ink bar, only when a mode is degraded. Live
 * modes render nothing: a degraded mode is never silent, a live one never
 * shouts (docs/ux/shell.md).
 */
export function ModeChips({ className }: { className?: string }) {
  const env = useEnvironment();
  if (!env.data) return null;
  const chips: Array<{ label: string; detail: string }> = [];
  if (env.data.loiMode === 'recorded') chips.push({ label: 'LOI: recorded', detail: 'LOI extraction replays the stored result instead of calling Bedrock. Details under Environment in the user menu.' });
  if (env.data.dictationMode === 'synthetic') chips.push({ label: 'Dictation: synthetic', detail: 'Dictation plays a synthetic transcript; no Deepgram key is configured. Details under Environment in the user menu.' });
  if (chips.length === 0) return null;
  return (
    <div className={cn('flex items-center gap-2', className)} data-slot="mode-chips">
      {chips.map((c) => (
        <Tooltip key={c.label}>
          <TooltipTrigger asChild>
            <span tabIndex={0} className="inline-flex h-6 items-center rounded-full border border-beam-warning-bg/60 px-2 text-xs font-medium whitespace-nowrap text-beam-warning-bg">
              {c.label}
            </span>
          </TooltipTrigger>
          <TooltipContent>{c.detail}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
